import React from "react"
import { Filters } from "../tickets/Filters"

export const TicketFilterModal = () => {
    return (
        <Filters/>
    )
}
